omadapp.controllers.coverController =function($page) {
    var t = this;
    var $ = jQuery
    t.$page = $page
    var app = omadapp.App
    var quiz = app.config.quizz
    t.inicializar = inicializar
    t.onCurrent = onCurrent

    var $js_quiz_type = $page.find(".js_quiz_type")
    var $js_title = $page.find(".js_title")
    var $js_body = $page.find(".js_body")

    function inicializar() {
    	$js_title.text(quiz.title)
        $js_quiz_type.text(quiz.pretitle)
    	$js_body.html(quiz.body)
    }



    function onCurrent() {
    }

}